import { render, staticRenderFns } from "./VerifySecurityQuestion.vue?vue&type=template&id=31a93419&scoped=true"
import script from "./VerifySecurityQuestion.vue?vue&type=script&lang=js"
export * from "./VerifySecurityQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a93419",
  null
  
)

export default component.exports